import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-display-terms',
  templateUrl: './display-terms.component.html',
  styleUrls: ['./display-terms.component.scss'],
})
export class DisplayTermsComponent {
  @Input() displayTerms;
  @Output() displayTermsChange = new EventEmitter<boolean>();
  constructor() {}

  hide() {
    this.displayTermsChange.emit(false);
  }
}
